import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import hljs from 'highlight.js'
import 'highlight.js/styles/monokai-sublime.css'

const Highlight = ({ content }) => {
  const nodeRef = React.createRef()

  useEffect(() => {
    if (nodeRef) {
      const nodes = nodeRef.current.querySelectorAll('pre')
      nodes.forEach((node) => {
        hljs.highlightBlock(node)
      })
    }
  })

  return <div ref={nodeRef} className='post-entry' dangerouslySetInnerHTML={{ __html: content }} />
}

Highlight.propTypes = {
  content: PropTypes.string
}

Highlight.defaultProps = {
  content: ''
}

export default Highlight
